import React from 'react';
import { BsInstagram, Bs1Circle, Bs0CircleFill } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <Bs1Circle />
    </div>
    <div>
      <Bs0CircleFill />
    </div>
    <div>
      <BsInstagram />
    </div>
  </div>
);

export default SocialMedia;
